module.exports = __webpack_public_path__ + "img/Patch17-1.72e37124.webp";